import React from "react";
import CalculRentabiliteLocative from "../components/CalculRentabiliteLocative";

export default function CalculRentabiliteLocativePage() {
  return <CalculRentabiliteLocative />;
}
